export default __webpack_public_path__ + "static/media/picture.cfc5f426.svg";